import Users from 'app/interface/redux/types/data/generic/users'

const Default: Users = {
  data: [],
  loading: true,
  timestamp: +new Date(),
}

export default Default
